export default function CsharpClassesObjects() {
  return (
    <h2>Csharp Classes Objects</h2>
  );
}
